import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const TagManager = () => {
  const location = useLocation();

  useEffect(() => {
    window.dataLayer = window.dataLayer || [];
    function gtag(){window.dataLayer.push(arguments);}
    gtag('config', 'G-JVHN5T3PXX', {
      'page_title': document.title,
      'page_path': location.pathname
    });
  }, [location]);

  return null;
};

export default TagManager;
